import { AvcTask, AvcTaskAssociation } from '@nativewaves/nw-cloud-sdk/content'
import { useQueries } from '@tanstack/react-query'

import { avcTaskQueryKeys } from 'services/queryKeys'

export type AvcTaskAssociationRow = AvcTaskAssociation & {
  /** Undefined while the task detail loads, or if the task is gone / not accessible. */
  task?: AvcTask
  isTaskLoading: boolean
}

/**
 * A stream stores only task ids, so each linked task is resolved separately to get its
 * name and state. Keyed per task, so rows share cache with the rest of the app.
 */
export const useAvcTaskAssociationRows = (associations: AvcTaskAssociation[]): AvcTaskAssociationRow[] => {
  const avcTaskQueries = useQueries({
    queries: associations.map((association) => avcTaskQueryKeys.detail({ taskId: association.taskId, view: 'Slim' })),
  })

  return associations.map((association, index) => ({
    ...association,
    task: avcTaskQueries.at(index)?.data,
    isTaskLoading: !!avcTaskQueries.at(index)?.isLoading,
  }))
}
